<template>
    <div class="qna_create">
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <div slot="headerBtns">
                <button class="h_search_btn" @click="$router.push('/search')"></button>
            </div>
        </page-header>
        <page-header class="sub_header"></page-header>
        <div class="qna_create_wrap dgm_wrap">
            <board-write-component :boardType="`qnaCreate`"></board-write-component>
            <div class="save_btn one_btn" @click="save">{{ $t('save') }}</div>
        </div>
    </div>

</template>

<script>
import EventBus from "@/utils/event-bus";
import BoardWriteComponent from "@/components/board/BoardWriteComponent";

export default {
    name: "QnaCreate",
    mixins: [],
    components: {
        BoardWriteComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        save() {
            EventBus.$emit('writeBoard');
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
